export function getStandardStatus(codeNumber) {
  let enumDictionary = {
    Approved: 0,
    ApprovedByHR: 20,
    ApprovedByHOU: 40,
    ApprovedByHOD: 50,
    ApprovedByEDO: 30,
    ApprovedByEDFI: 60,
    ApprovedByMD: 10,
    RejectedByHR: 81,
    RejectedByHOU: 729,
    RejectedByHOD: 243,
    RejectedByEDO: 9,
    RejectedByEDFI: 27,
    RejectedByMD: 3,
    Pending: 1,
    Declined: 7,
    Cancelled: 11,
    Paid: 13,
    Draft: 17,
    Retired: 14,
    Closed: 2,
    Rejected: 4,
  };

  let enumList = Object?.entries(enumDictionary);
  let statusText;

  if (codeNumber >= 0) {
    let status = enumList?.find((entry) => entry[1] === codeNumber);
    if (status) {
      statusText = status[0];
    } else {
      statusText = `Unknown Status (${codeNumber})`;
    }
    return statusText;
  }
  return enumList;
}
export function getAppraisalStandardStatus(codeNumber) {
  let enumDictionary = {
    Approved: 0,
    ApprovedByHR: 20,
    ApprovedByHOU: 40,
    ApprovedByHOD: 50,
    ApprovedByEDO: 30,
    ApprovedByEDFI: 60,
    ApprovedByMD: 10,
    ApprovedByPJL: 12,
    RejectedByHR: 81,
    RejectedByHOU: 729,
    RejectedByHOD: 243,
    RejectedByEDO: 9,
    RejectedByEDFI: 27,
    RejectedByMD: 3,
    Rejected: 4,
    Pending: 1,
    ApprovedByControlReviewer: 101,
    ApprovedByControlApprover: 102,
    RejectedByControl: 104,
  };

  let enumList = Object?.entries(enumDictionary);
  let statusText;

  if (codeNumber >= 0) {
    let status = enumList?.find((entry) => entry[1] === codeNumber);
    if (status) {
      statusText = status[0];
    } else {
      statusText = `Unknown Status (${codeNumber})`;
    }
    return statusText;
  }
  return enumList;
}
